// field-utils.ts
import { FormConfig, FieldConfig, FieldType } from 'components/Forms/types'
import { CREATIVE_FIELDS } from 'components/Tasks/CREATIVE_FIELDS'
import { Task } from 'types'

export type ConfigMap = Record<string, FieldConfig>

export function getTypeConfigs(task: Task): { top: ConfigMap; extra: ConfigMap } {
  const type = task?.type as string
  return {
    top: (FormConfig as any)?.[type] ?? {},
    extra: (CREATIVE_FIELDS as any)?.[type] ?? {},
  }
}

// Pull initial values for editing (top-level + extraFields)
// export function buildInitialValues(task: Task, top: ConfigMap, extra: ConfigMap) {
//   const topVals = Object.fromEntries(Object.keys(top).map(k => [k, task?.[k] ?? getDefault(top[k])]))
//   const extraVals = Object.fromEntries(Object.keys(extra).map(k => [k, task?.extraFields?.[k] ?? getDefault(extra[k])]))
//   return { ...topVals, ...extraVals }
// }
export function buildInitialValues(task: Task, top: ConfigMap, extra: ConfigMap) {
  const topVals = Object.fromEntries(Object.keys(top).map(k => [k, task?.[k] ?? getDefault(top[k])]))
  const extraVals = Object.fromEntries(Object.keys(extra).map(k => [k, task?.extraFields?.[k] ?? getDefault(extra[k])]))
  return { ...topVals }
}

function getDefault(cfg: FieldConfig) {
  if (cfg.type === FieldType.MULTISELECT) return []
  if (cfg.type === FieldType.NUMBER) return ''
  return ''
}

// Split the edited values into top-level vs extraFields + compute diffs
export function splitPatchesForSave(task: Task, values: Record<string, any>, top: ConfigMap, extra: ConfigMap) {
  const original = {
    ...Object.fromEntries(Object.keys(top).map(k => [k, task?.[k]])),
    // ...Object.fromEntries(Object.keys(extra).map(k => [k, task?.extraFields?.[k]])),
  }

  const changed: Record<string, any> = {}
  for (const [k, v] of Object.entries(values)) {
    const prev = original[k]
    const isChanged = Array.isArray(v) ? JSON.stringify(prev ?? []) !== JSON.stringify(v ?? []) : prev !== v
    if (isChanged) changed[k] = v
  }

  const topPatch: Record<string, any> = {}
  const extraPatch: Record<string, any> = {}
  Object.keys(changed).forEach(k => {
    if (k in top) topPatch[k] = changed[k]
    else if (k in extra) extraPatch[k] = changed[k]
  })
  return { topPatch, extraPatch }
}
